module.exports = __webpack_public_path__ + "img/selected6-min.7b9c8f89.png";